import { useMutation } from "@tanstack/react-query";
import urls from "../../../../../../urls";
import { useDownloadVollmacht } from "./useDownloadVollmacht";

function useDownloadVollmachtMsb(siteId: number) {
  const { generateAndDownloadVollmacht } = useDownloadVollmacht(siteId, {
    canGenerateUrl: urls.api.siteCanGenerateMsbDocuments,
    generateUrl: urls.api.generateMsbVollmacht,
    getUrl: urls.api.getMsbVollmacht
  });

  const generateAndDownloadVollmachtMsbMutation = useMutation({
    mutationFn: () => generateAndDownloadVollmacht()
  });

  return {
    generateAndDownloadVollmachtMsbMutation
  };
}

export { useDownloadVollmachtMsb };
